// extracted by mini-css-extract-plugin
module.exports = {"btnsWrap":"Method_btnsWrap_3S3-T","card_alert":"Method_card_alert_tTIyf"};